import differenceBy from 'lodash/differenceBy';
import {
  LOTTERY_SERIAL_DATA_REQUEST,
  LOTTERY_SERIAL_DATA_SUCCESS,
  LOTTERY_SERIAL_DATA_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOTTERY_SERIAL_DATA_REQUEST:
      return { ...state, isLoading: true, error: null };
    case LOTTERY_SERIAL_DATA_SUCCESS: {

      const { ticketType, serialType = null, selectedTickets, quarter, half, full } = action.payload;
      
      // Gelen seri bilet dataları.
      let ticketsQuarter = quarter?.serialTickets || [];
      let ticketsHalf = half?.serialTickets || [];
      let ticketsFull = full?.serialTickets || [];

      // Sadece seçilen ticketType a göre datayı güncelle.
      if (ticketType === 'QUARTER') {

        ticketsHalf = state.data.half.serialTickets || [];
        ticketsFull = state.data.full.serialTickets || [];

      } else if (ticketType === 'HALF') {

        ticketsQuarter = state.data.quarter.serialTickets || [];
        ticketsFull = state.data.full.serialTickets || [];

      } else if (ticketType === 'FULL') {

        ticketsQuarter = state.data.quarter.serialTickets || [];
        ticketsHalf = state.data.half.serialTickets || [];
      }
      
      // Seçilen tab'a göre seçili biletler ayrıştırılır.
      const sameSelectedTicketsQuarter = selectedTickets.filter(ticketItem => ticketItem.ticketType === 'QUARTER' && ticketItem.serialType === serialType);
      const sameSelectedTicketsHalf = selectedTickets.filter(ticketItem => ticketItem.ticketType === 'HALF' && ticketItem.serialType === serialType);
      const sameSelectedTicketsFull = selectedTickets.filter(ticketItem => ticketItem.ticketType === 'FULL' && ticketItem.serialType === serialType);

      // Gelen datanın içerisinde daha önce seçilmişlerden varsa, onları siliyoruz.
      const removeSelectedsQuarter = differenceBy(ticketsQuarter, sameSelectedTicketsQuarter, 'serialCode');
      const removeSelectedsHalf = differenceBy(ticketsHalf, sameSelectedTicketsHalf, 'serialCode');
      const removeSelectedsFull = differenceBy(ticketsFull, sameSelectedTicketsFull, 'serialCode');

      // Yukarıdaki silme işine istinaden gelen datadan çıkarılacak bilet sayısını hesaplıyoruz.
      const trimSizeQuarter = sameSelectedTicketsQuarter.length - (ticketsQuarter.length - removeSelectedsQuarter.length);
      const trimSizeHalf = sameSelectedTicketsHalf.length - (ticketsHalf.length - removeSelectedsHalf.length);
      const trimSizeFull = sameSelectedTicketsFull.length - (ticketsFull.length - removeSelectedsFull.length);

      // Gelen datadan seçilen bilet kadar data atılır.
      const trimmedTicketsQuarter = trimSizeQuarter > 0 ? removeSelectedsQuarter.slice(0, -trimSizeQuarter) : removeSelectedsQuarter;
      const trimmedTicketsHalf = trimSizeHalf > 0 ? removeSelectedsHalf.slice(0, -trimSizeHalf) : removeSelectedsHalf;
      const trimmedTicketsFull = trimSizeFull > 0 ? removeSelectedsFull.slice(0, -trimSizeFull) : removeSelectedsFull;

      // Gelen datanın baş kısmına seçilen biletler eklenir.
      const updatedTicketsQuarter = sameSelectedTicketsQuarter.length > 0 ? [...sameSelectedTicketsQuarter, ...trimmedTicketsQuarter] : trimmedTicketsQuarter;
      const updatedTicketsHalf = sameSelectedTicketsHalf.length > 0 ? [...sameSelectedTicketsHalf, ...trimmedTicketsHalf] : trimmedTicketsHalf;
      const updatedTicketsFull = sameSelectedTicketsFull.length > 0 ? [...sameSelectedTicketsFull, ...trimmedTicketsFull] : trimmedTicketsFull;
      
      // Ek field'lar eklenir. Bu field'lar lottery slip için gereklidir.
      let enrichedTicketsQuarter = updatedTicketsQuarter.map(ticketItem => ({ ...ticketItem, ticketPrice: quarter.ticketPrice, serialType: serialType }));
      let enrichedTicketsHalf = updatedTicketsHalf.map(ticketItem => ({ ...ticketItem, ticketPrice: half.ticketPrice, serialType: serialType }));
      let enrichedTicketsFull = updatedTicketsFull.map(ticketItem => ({ ...ticketItem, ticketPrice: full.ticketPrice, serialType: serialType }));

      // Güncellenmiş reducer datamızı oluşturuyoruz.
      const updatedPayload = {
        ...action.payload,
        quarter: {
          ...action.payload.quarter,
          serialTickets: enrichedTicketsQuarter
        },
        half: {
          ...action.payload.half,
          serialTickets: enrichedTicketsHalf
        },
        full: {
          ...action.payload.full,
          serialTickets: enrichedTicketsFull
        },
      };

      return {
        data: {
          ...updatedPayload
        }, isLoading: false, error: null };
    }
      
    case LOTTERY_SERIAL_DATA_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
